module.exports = __webpack_public_path__ + "static/img/mobile_img.8d3b87c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build08/components/base/jackpot/mobile_img.png
// module id = uBXV
// module chunks = 43